export function formatLocation(place = {}) {
  const byType = (place.address_components || []).reduce(function (acc, data) {
    data.types.forEach(function (type) {
      acc[type] = data
    })
    return acc
  }, {})

  function placeGet(key, short) {
    if (!(key in byType)) return ''

    return short ? byType[key].short_name : byType[key].long_name
  }

  const city =
    placeGet('locality') ||
    placeGet('sublocality') ||
    placeGet('sublocality_level_1') ||
    placeGet('neighborhood') ||
    placeGet('administrative_area_level_3') ||
    placeGet('administrative_area_level_2')
  const stateShort = placeGet('administrative_area_level_1', true)
  const country = placeGet('country')

  if (!city && !stateShort) {
    return country
  } else {
    return `${city}${city && ','} ${stateShort}`.trim()
  }
}
